export default "__VITE_ASSET__8a9feb37__"